import { InjectionToken } from '@angular/core';

export const ICONS_BASE_URL = new InjectionToken<string>('ICONS_BASE_URL');
